import type { Hit } from 'bundles/internal-search/types';
import type { SearchProductHit } from 'bundles/search-common/providers/searchTypes';

// Helper function to capitalize first letter and make rest lowercase
const capitalizeFirstLetter = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// Helper function to format product type (replace underscores with spaces)
const formatProductType = (productType: string): string => {
  if (!productType) return productType;
  return productType.replace(/_/g, ' ');
};

// Adapter function to map SearchProductHit to DesktopSearchCard's expected format
export const adaptSearchDataToLegacyCards = (hit: SearchProductHit): Hit => ({
  avgProductRating: hit.avgProductRating || 0,
  numProductRatings: hit.numProductRatings || 0,
  partners: hit.partners || [],
  isPartOfCourseraPlus: hit.isPartOfCourseraPlus || false,
  imageUrl: hit.imageUrl || '',
  objectID: hit.id || '',
  objectUrl: hit.url || '',
  name: hit.name || '',
  productDifficultyLevel: capitalizeFirstLetter(hit.productDifficultyLevel || ''),
  entityType: formatProductType(hit.productType || ''),
  tagline: hit.tagline || '',
  partnerLogos: hit.partnerLogos || [],
  skills: hit.skills || [],
  enrollments: 0,
  avgLearningHours: 0,
  description: hit.tagline || '',
  subtitleLanguage: [],
  language: '',
  entityTypeDescription: '',
});
